import React from 'react'
import { ATLTextBody } from '@appsimples/atlantica-react-native'
import styled from 'styled-components/native'
import { atlTheme } from '../atlTheme'
import { screenWidth } from '../constants/dimensions'

const ComponentContainer = styled.View`
  flex-direction: row;
  align-items: flex-start;
`

export interface TextTwoColorsProps {
  firstText: string
  secondText: string
}

export const TextTwoColors: React.FunctionComponent<TextTwoColorsProps> = ({ firstText, secondText }) => {
  return (
    <ComponentContainer>
      <ATLTextBody
        verticalMargin={0.1}
        horizontalMargin={4}
        labelBaseProps={{ multilineLimit: 1, textColor: atlTheme.ColorBrand1Default }}
      >
        {firstText}
      </ATLTextBody>
      <ATLTextBody
        verticalMargin={0.1}
        horizontalMargin={0.1}
        labelBaseProps={{ multilineLimit: 10, textColor: atlTheme.ColorHighContrast }}
      >
        {secondText}
      </ATLTextBody>
    </ComponentContainer>
  )
}
